export interface StakeValidationResult {
    message: string;
    type: string;
    isValid?: boolean;
    callback?: Function;
    minimumStake?: string;
}

export enum StakeErrorType {
    MoreThanBalance = 'NotEnoughMoney',
    NotMultiple = 'NotMultiple',
    LessThanMinPerBet = 'MinStakePerBet',
    LessThanMinTotal = 'MinStakeTotal',
    LessThanMin = 'MinStakeValue',
    LessStakeAfterTax = 'LessStakeAfterTax',
}
